import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { ConfigServiceService } from '../../../shared/config-service.service';

export interface DialogData {
  id: string
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  coverageDetails = {};

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
      private configService: ConfigServiceService) {}

  ngOnInit() {
    this.configService.getInfoConfig()
      .subscribe((data) => {
        this.coverageDetails = data[ parseInt(this.dialogData.id)-1]
      });
  }

  close() {
    this.dialogRef.close();
  }

}
